export default __webpack_public_path__ + "static/shipping-1-559f08fe79166115953de0451860b237.jpg";